import React from 'react'
import { Link } from 'react-router-dom'
import { PageTitle } from 'src/components/PageTitle'
import ROUTES from 'src/constants/routes'
import { AnimalRegistrationSwitch } from './AnimalSwitchRegistration'
import { useStyles } from '../styles'

interface Props {
  isCompleteAnimalRegistration: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  showSwitch?: boolean
}

export const CreateAnimalHeader: React.FC<Props> = ({ isCompleteAnimalRegistration, onChange, showSwitch = true }) => {
  const styles = useStyles()

  return (
    <div className={styles.header}>
      <PageTitle>
        <Link to={ROUTES.ANIMAL.ROOT}>Gado</Link>
        {' > '} Cadastrar animal
      </PageTitle>

      {showSwitch && (
        <AnimalRegistrationSwitch isCompleteAnimalRegistration={isCompleteAnimalRegistration} handleChange={onChange} />
      )}
    </div>
  )
}
